<!--
 * @Descripttion: 打卡记录
 * @Author: juanjuanhui
 * @Date: 2022-04-29 10:26:13
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-04-29 14:07:45
-->
<template>
  <div class="clockin-detail">
    <el-tabs v-model="activeName">
      <el-tab-pane label="打卡记录" name="first">
        <ul class="list">
          <li class="item">姓名：{{ curMarkerVal.employeeName }}</li>
          <li class="item">打卡时间：{{ curMarkerVal.createTime }}</li>
          <li class="item">打卡位置：{{ curMarkerVal.address }}</li>
        </ul>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "first",
    };
  },
  props: {
    curMarkerVal: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.clockin-detail {
  .list {
    margin-top: 10px;
    .item {
      color: #fff;
      line-height: 26px;
    }
  }
}
</style>
